<template>
	<div>
		<!-- 无子集 -->
		<el-menu-item :index="item.url" v-if="!item.children">
			<i :class="item.icon"></i>
			<span slot="title">{{ item.name }}</span>
		</el-menu-item>

		<!-- 有子集 -->
		<el-submenu v-else :index="item.url">
			<template slot="title">
				<div class="submenu-title">
					<i :class="item.icon" v-if="item.icon"></i>
					<span :style="!msg ? { 'padding-left': '0' } : { 'padding-left': '1rem' }">{{ item.name }}</span>
				</div>
			</template>

			<!-- 子菜单项 -->
			<template v-for="children in item.children">
				<el-menu-item v-if="!children.children" :key="children.url" :index="children.url">
					<i :class="children.icon" v-if="children.icon"></i>
					<span :style="!msg ? { 'padding-left': '0' } : { 'padding-left': '1rem' }">{{ children.name
						}}</span>
				</el-menu-item>

				<!-- 递归处理嵌套子菜单项 -->
				<Nav v-else :key="item.url" :item="children" :msg="msg"></Nav>
			</template>
		</el-submenu>
	</div>
</template>

<script>
export default {
	name: "Nav",
	props: ["msg", "item"],
};

</script>

<style scoped>
.submenu-fade-enter-active,
.submenu-fade-leave-active {
	transition: all 0.3s ease;
}

.submenu-fade-enter,
.submenu-fade-leave-to {
	opacity: 0;
	transform: translateY(-10px);
}

/* 确保子菜单项的宽度不受影响 */
.el-submenu .el-menu {
	transition: all 0.3s ease;
}

.submenu-title {
	display: flex;
	align-items: center;
}
</style>

<style>
.el-submenu .el-icon-arrow-right {
	display: none !important;
}

/* 调整弹出菜单样式 */
.el-menu--popup {
	min-width: 150px;
	/* 设置最小宽度 */
	background-color: #fff;
	/* 设置背景颜色 */
	border: 1px solid #e6e6e6;
	/* 设置边框 */
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	/* 添加阴影 */
}

.el-menu--popup .el-menu-item {
	padding: 0 20px;
	/* 设置内边距 */
	white-space: nowrap;
	/* 防止文字换行 */
}

.el-menu--popup .el-menu-item:hover {
	background-color: #ecf5ff;
	/* 设置悬停背景颜色 */
}

/* 确保在折叠状态下弹出菜单正确显示 */
.el-menu--collapse .el-menu--popup {
	left: 100%;
	top: 0;
	position: absolute;
	z-index: 1000;
}

/* 确保子菜单项在折叠状态下可见 */
.el-menu--collapse .el-menu-item span {
	display: inline-block;
}

.Mycell {
	display: none;
}

@media (max-width: 1030px),
(max-device-width: 1030px) and (orientation: landscape) {

	.el-menu--popup {
		min-width: 2rem !important;
		width: 13rem !important;
	}

	.submenu-title i {
		margin-right: 4rem !important;
		/* 设置内边距 */
		white-space: nowrap;
		/* 防止文字换行 */
	}

	.el-menu--popup .submenu-title {
		padding-left: 0rem !important;
		/* 设置内边距 */
		white-space: nowrap;
		/* 防止文字换行 */
	}

	.el-menu--popup .submenu-title i {
		margin-right: 0rem !important;
	}

	.MyTable {
		display: none;
	}

	.Mycell {
		display: block;

	}

}
</style>